import React from 'react'

const useStudentEnrolment = () => {
    const [enrolmentSearchValue, setEnrolmentSearchValue] = React.useState({
      SessionId: "1",
    });
    const [loading, setLoading] = React.useState(false)
    const [currentItems, setCurrentItems] = React.useState([
      {
        District_Name: "Ambala",
        Balwatika: 2771,
        First: 3244,
        Second: 3510,
        Third: 4842,
        Fourth: 5970,
        Fifth: 6116,
        Total: 26453,
      },
      {
        District_Name: "Bhiwani",
        Balwatika: 3572,
        First: 4016,
        Second: 3454,
        Third: 5446,
        Fourth: 7320,
        Fifth: 7603,
        Total: 31411,
      },
      {
        District_Name: "Charkhi Dadri",
        Balwatika: 1588,
        First: 1441,
        Second: 1247,
        Third: 1740,
        Fourth: 2493,
        Fifth: 2636,
        Total: 11145,
      },
      {
        District_Name: "Faridabad",
        Balwatika: 2256,
        First: 5362,
        Second: 7463,
        Third: 9215,
        Fourth: 10989,
        Fifth: 11476,
        Total: 46761,
      },
      {
        District_Name: "Fatehabad",
        Balwatika: 4412,
        First: 4548,
        Second: 4297,
        Third: 6578,
        Fourth: 8710,
        Fifth: 9001,
        Total: 37546,
      },
      {
        District_Name: "Gurugram",
        Balwatika: 3458,
        First: 7509,
        Second: 9474,
        Third: 11707,
        Fourth: 13217,
        Fifth: 14260,
        Total: 59625,
      },
      {
        District_Name: "Hisar",
        Balwatika: 4931,
        First: 5756,
        Second: 5807,
        Third: 9050,
        Fourth: 10794,
        Fifth: 11545,
        Total: 47883,
      },
      {
        District_Name: "Jhajjar",
        Balwatika: 1941,
        First: 2683,
        Second: 2992,
        Third: 3804,
        Fourth: 4540,
        Fifth: 4543,
        Total: 20503,
      },
      {
        District_Name: "Jind",
        Balwatika: 4706,
        First: 4673,
        Second: 4914,
        Third: 7381,
        Fourth: 8473,
        Fifth: 9225,
        Total: 39372,
      },
      {
        District_Name: "Kaithal",
        Balwatika: 4071,
        First: 4130,
        Second: 4113,
        Third: 6456,
        Fourth: 8095,
        Fifth: 8496,
        Total: 35361,
      },
      {
        District_Name: "Karnal",
        Balwatika: 5526,
        First: 5945,
        Second: 6306,
        Third: 9774,
        Fourth: 11369,
        Fifth: 11931,
        Total: 50851,
      },
      {
        District_Name: "Kurukshetra",
        Balwatika: 2946,
        First: 3662,
        Second: 3619,
        Third: 5435,
        Fourth: 6570,
        Fifth: 6789,
        Total: 29021,
      },
      {
        District_Name: "Mahendragarh",
        Balwatika: 2277,
        First: 2362,
        Second: 2128,
        Third: 3239,
        Fourth: 4614,
        Fifth: 4548,
        Total: 19168,
      },
      {
        District_Name: "Nuh Mewat",
        Balwatika: 10628,
        First: 20402,
        Second: 24606,
        Third: 29032,
        Fourth: 33610,
        Fifth: 29057,
        Total: 147335,
      },
      {
        District_Name: "Palwal",
        Balwatika: 3970,
        First: 6683,
        Second: 7692,
        Third: 10389,
        Fourth: 13264,
        Fifth: 13363,
        Total: 55361,
      },
      {
        District_Name: "Panchkula",
        Balwatika: 2472,
        First: 3505,
        Second: 3948,
        Third: 5216,
        Fourth: 5787,
        Fifth: 6303,
        Total: 27231,
      },
      {
        District_Name: "Panipat",
        Balwatika: 3909,
        First: 5813,
        Second: 7463,
        Third: 9063,
        Fourth: 9623,
        Fifth: 10094,
        Total: 45965,
      },
      {
        District_Name: "Rewari",
        Balwatika: 2049,
        First: 2539,
        Second: 2612,
        Third: 3803,
        Fourth: 4791,
        Fifth: 5179,
        Total: 20973,
      },
      {
        District_Name: "Rohtak",
        Balwatika: 1944,
        First: 2643,
        Second: 2988,
        Third: 4039,
        Fourth: 4659,
        Fifth: 5073,
        Total: 21346,
      },
      {
        District_Name: "Sirsa",
        Balwatika: 5722,
        First: 6427,
        Second: 6663,
        Third: 9498,
        Fourth: 11598,
        Fifth: 11752,
        Total: 51660,
      },
      {
        District_Name: "Sonipat",
        Balwatika: 4333,
        First: 6648,
        Second: 7456,
        Third: 8734,
        Fourth: 9757,
        Fifth: 9736,
        Total: 46664,
      },
      {
        District_Name: "Yamunanagar",
        Balwatika: 3964,
        First: 4701,
        Second: 5149,
        Third: 7467,
        Fourth: 8771,
        Fifth: 9597,
        Total: 39649,
      },
      {
        District_Name: "Total",
        Balwatika: 83446,
        First: 114692,
        Second: 127901,
        Third: 171908,
        Fourth: 205014,
        Fifth: 208323,
        Total: 911284,
      },
    ]); // Specify the type here

    const headers = [
      { label: "District_Name", key: "District_Name" },
      { label: "Balwatika", key: "Balwatika" },
      { label: "First", key: "First" },
      { label: "Second", key: "Second" },
      { label: "Third", key: "Third" },
      { label: "Fourth", key: "Fourth" },
      { label: "Fifth", key: "Fifth" },
      { label: "Total", key: "Total" },
    ];

  const handleChangeenrolmentSearch = ({
    name,
    value,
  }: {
    name: string;
    value: any;
  }) => {
    setEnrolmentSearchValue((prev) => {
      return {
        ...prev,
        [name]: value,
      };
    });
  };
  return {
    enrolmentSearchValue,
    handleChangeenrolmentSearch,
    loading,
    currentItems,
    setLoading,
    headers,
  };
}

export default useStudentEnrolment